import PageTransition from "@/components/site/PageTransition";
import PageHero from "@/components/site/PageHero";
import Services from "@/components/site/Services";
import { useStartInquiryForPackage } from "@/lib/useInquiry";

export default function ServicesPage() {
    const choose = useStartInquiryForPackage();
    return (
        <PageTransition>
            <PageHero
                crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
                eyebrow="Services · Engagements"
                title="Ways to work {gold:together}."
                intro="From a focused logo system to a full brand ecosystem, choose the level of ambition that fits where your brand is headed."
                tone="warm"
            />
            <Services onChoosePackage={choose} />
        </PageTransition>
    );
}
